import PropTypes from 'prop-types';
import { useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownThreeDotsIcon } from '@hivebrite/design-system/Dropdown';
import { Link } from '@hivebrite/design-system/Link';
import { UserPresentation } from '@hivebrite/design-system/UserPresentation';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const DropdownButton = ({ actions }) => (
  <BoxStyled display="block" height={30}>
    <DropdownThreeDotsIcon
      dataTestId="user-card-actions-dropdown"
      items={actions}
      position="left"
    />
  </BoxStyled>
);

DropdownButton.propTypes = {
  actions: PropTypes.array.isRequired,
};

export const HeaderWithUserInfo = ({ src, name, date, to }) => {
  const renderUserInfo = useMemo(
    () => (
      <Box pt={4} pb={3} dataTestId="file-header-picture">
        <UserPresentation
          avatar={src}
          name={
            <HeaderUserLink styledOnlyOnHover to={to} tabIndex="0">
              {name}
            </HeaderUserLink>
          }
          headline={dayjs(date).fromNow()}
        />
      </Box>
    ),
    [src, name, date, to],
  );

  return renderUserInfo;
};

HeaderWithUserInfo.propTypes = {
  date: PropTypes.string.isRequired,
  name: PropTypes.node.isRequired,
  src: PropTypes.string.isRequired,
  to: PropTypes.object,
};

export const HeaderWithoutUserInfo = ({ date }) => (
  <Box flexGrow={2} py={5}>
    <Box alignItems="center" data-testid="thumbnail-header-date">
      {dayjs(date).fromNow()}
    </Box>
  </Box>
);

HeaderWithoutUserInfo.propTypes = {
  date: PropTypes.string.isRequired,
};

const ThumbnailHeader = ({
  actions = [],
  date,
  isFolder = false,
  owner,
  to = {},
  withUserInformations = false,
}) => (
  <Box justifyContent="space-between" px={4}>
    {withUserInformations ? (
      <HeaderWithUserInfo
        src={owner.photo}
        name={owner.name}
        date={date}
        to={to}
      />
    ) : (
      <HeaderWithoutUserInfo date={date} />
    )}
    {!(withUserInformations && isFolder) && actions?.length > 0 && (
      <Box width="30px" justifyContent="flex-end" pt={3}>
        <DropdownButton actions={actions} />
      </Box>
    )}
  </Box>
);

ThumbnailHeader.propTypes = {
  actions: PropTypes.array,
  date: PropTypes.string.isRequired,
  isFolder: PropTypes.bool,
  owner: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.string,
  }),
  to: PropTypes.object,
  withUserInformations: PropTypes.bool,
};

export default ThumbnailHeader;

const BoxStyled = styled(Box)`
  button {
    max-height: 30px;
    padding: 0;
  }
`;

const HeaderUserLink = styled(Link)`
  &:hover {
    text-underline-position: auto;
  }
`;
